export default __webpack_public_path__ + "static/media/tokenImageXbank.eb9db22e.svg";